import { Component, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ContratoService } from '../../../../providers/contrato-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

import { IMyDrpOptions, IMyDateRangeModel, IMyDateRange } from 'mydaterangepicker';

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

declare var jsPDF: any;

@Component({
  selector: 'page-cadastro-contratos',
  templateUrl: 'cadastro-contratos.html',
  providers: [
    ContratosGestaoService
  ]
})
export class CadastroContratosPage extends ModulosController {
  listaDados: any = [];
  objetoDateRange: any;
  listaTiposVinculos: any = [];
  listaCargo: any = [];
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "141";
  tiposArquivosAceitos: string = "application/xls";
  dadosImportados: any[];
  searchLoading: boolean = true;
  listaContratos: any = [];
  habilita: boolean = true;
  codigoModuloContrato: any = null;

  dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  cpfPreenchido: boolean = false;
  cpfCarregado: boolean = true;
  cpfInvalido: boolean = false;

  cnpjPreenchido: boolean = false;
  cnpjCarregado: boolean = true;
  cnpjInvalido: boolean = false;

  contratoParaAdicionar: any = {
    nmContrato: '',
    dsCredor: '',
    cpf: '',
    cnpj: '',
    objeto: '',
    valorContratado: '',
    inicioVigencia: '',
    fimVigencia: ''
  }

  numberMask = createNumberMask({
    prefix: '',
    suffix: '', // This will put the dollar sign at the end, with a space.
    thousandsSeparatorSymbol: '',
    allowDecimal: false,
    decimalSymbol: ',',
    allowLeadingZeroes: true
  });

  myDateRangePickerOptions: IMyDrpOptions;
  selectedDateRange: IMyDateRange;

  selectedText: string = '';
  border: string = 'none';

  placeholderTxt: string = 'Selecione o Período...';

  idModuloPCA: any;

  typeahead = new EventEmitter<string>();

  objetoEdit: any = null;
  listEdit: any = [];
  codigoModulo: any = 0;
  comboContratos: any = null;
  analise: any = null;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public contratosGestaoService: ContratosGestaoService,
    private fileService: FileService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    if (this.isJurisdicionado) {
      this.codigoModulo = this.navParams.get('analise').idModuloPca;
    }

    this.contratoService.obterModuloPca().subscribe(moduloPca => {
      if(moduloPca) {
          this.codigoModuloContrato = moduloPca.idModuloPca;
      }
      this.carregarDados();
  }, error => {
      console.log(error);
  });

    this.myDateRangePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: {
        1: 'Jan',
        2: 'Fev',
        3: 'Mar',
        4: 'Abr',
        5: 'Mai',
        6: 'Jun',
        7: 'Jul',
        8: 'Ago',
        9: 'Set',
        10: 'Out',
        11: 'Nov',
        12: 'Dez'
      },
      firstDayOfWeek: 'su',
      showApplyBtn: false,
      showClearDateRangeBtn: false,
      selectBeginDateTxt: 'Selecione a Data de Início',
      selectEndDateTxt: 'Selecione a Data de Fim',
      openSelectorOnInputClick: true,
      editableDateRangeField: false,
      width: '100%',
      componentDisabled: true
    };

    this.idModuloPCA = this.navParams.get('analise').idModuloPca
    this.analise = this.navParams.get('analise');

    this.carregarDados();
    this.setModuloId(7);

    this.typeahead.pipe(
        distinctUntilChanged(), 
        debounceTime(200), 
        switchMap(term => this.buscarContratos(term))).subscribe(items => {
          this.listaContratos = items;
        }, (err) => {
          console.log(err);
          this.listaContratos = [];
      });
  }

  buscarContratos(term: string): Observable<any[]> {
    return this.contratoService.listarContratosPcaPorNumero(term);
  }

  carregarDados() {
    this.contratosGestaoService.obterContratosGestao().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });

    // this.contratoService.listarPorPCA().subscribe(data => {
    //     this.listaContratos = data;
    //     this.searchLoading = false;
    // }, error => {
    //     console.log("erro: " + error);
    //     this.searchLoading = false;
    // });
  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {
        this.loading = true;
        this.fileService.cargaContratosGestao(event).subscribe(data => {
          this.inputFileCMVar.nativeElement.value = "";
          this.dadosImportados = data;

          for (let j = 0; j < this.dadosImportados.length; j++) {
              this.listaDados.push(this.dadosImportados[j]);
          }

          this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
          this.loading = false;
        }, error => {
          this.inputFileCMVar.nativeElement.value = "";
          this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
          this.loading = false;
        });
      } else {
        this.inputFileCMVar.nativeElement.value = "";
      }
    });
  }

  onCPFAlterado() {
    if (this.validarCPF(this.contratoParaAdicionar.cpf)) {
      this.cpfInvalido = false;
    }
    else {
      this.cpfPreenchido = false;
    }
  }

  onCNPJAlterado() {
    if (this.validarCNPJ(this.contratoParaAdicionar.cnpj)) {
      this.cnpjInvalido = false;
    }
    else {
      this.cnpjPreenchido = false;
    }
  }

  cpf_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  cnpj_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  validarCPF(cpf) {
    let ehValido = true;

    cpf = cpf.replace(/[^\w\s]/gi, '');

    if (cpf == '') {
      this.cpfInvalido = false;
      return false;
    }

    if (cpf.length != 11) {
      this.cpfInvalido = false;
      return false;
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
      cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
      cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      this.cpfInvalido = true;
      return false;
    }

    return ehValido;
  }

  validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') {
      this.cnpjInvalido = false;
      return false;
    }

    if (cnpj.length != 14) {
      this.cnpjInvalido = false;
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999") {
      this.cnpjInvalido = true;
      return false;
    }

    let tamanho: any;
    let numeros: any;
    let digitos: any;
    let soma: any;
    let pos: any;
    let resultado: any;

    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      this.cnpjInvalido = true;
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      this.cnpjInvalido = true;
      return false;
    }

    //this.cnpjInvalido = true;
    return true;
  }

  downloadDoModelo() {
    this.fileService.downloadModeloCargaContratoGestao(this.idSecaoPagina);
  }

  adicionarContrato() {
    if (this.contratoParaAdicionar.nmContrato != '' &&
      this.contratoParaAdicionar.dsCredor != '' &&
      this.contratoParaAdicionar.valorContratado != '' &&
      (this.contratoParaAdicionar.cnpj != '' || this.contratoParaAdicionar.cpf != '') &&
      this.contratoParaAdicionar.inicioVigencia != '' &&
      this.contratoParaAdicionar.fimVigencia != '' &&
      this.contratoParaAdicionar.objeto != '') {

      let contratoNovo = {
        "idContratoGestao": 0,
        "nmContrato": this.contratoParaAdicionar.nmContrato,
        "dsCredor": this.contratoParaAdicionar.dsCredor,
        "cpf": this.contratoParaAdicionar.cpf,
        "cnpj": this.contratoParaAdicionar.cnpj,
        "objeto": this.contratoParaAdicionar.objeto,
        "valorContratado": this.contratoParaAdicionar.valorContratado,
        "idModuloPca": this.idModuloPCA,
        "inicioVigencia": this.contratoParaAdicionar.inicioVigencia,
        "fimVigencia": this.contratoParaAdicionar.fimVigencia
      };

      if (this.listaDados.findIndex(i => i.nmContrato === contratoNovo.nmContrato) != -1 && !this.objetoEdit) {
        this.alertService.mostraAlerta("", "Contrato já adicionado!");
      }
      else {

        if (this.objetoEdit) {
          let index = this.listaDados.indexOf(this.objetoEdit);
          this.listaDados.splice(index, 1);

          this.listEdit.push(this.objetoEdit);
        }

        this.listaDados.push(contratoNovo);

        this.objetoEdit = null;

        this.contratoParaAdicionar.nmContrato =
          this.contratoParaAdicionar.dsCredor =
          this.contratoParaAdicionar.cpf =
          this.contratoParaAdicionar.cnpj =
          this.contratoParaAdicionar.objeto =
          this.contratoParaAdicionar.valorContratado =
          this.contratoParaAdicionar.inicioVigencia =
          this.contratoParaAdicionar.fimVigencia = '';

        this.comboContratos = null;

        let copy = {
          dateFormat: 'dd/mm/yyyy',
          dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
          monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
          },
          firstDayOfWeek: 'su',
          showApplyBtn: false,
          showClearDateRangeBtn: false,
          selectBeginDateTxt: 'Selecione a Data de Início',
          selectEndDateTxt: 'Selecione a Data de Fim',
          openSelectorOnInputClick: true,
          editableDateRangeField: false,
          width: '100%'
        };

        this.myDateRangePickerOptions = copy;
        this.clearDateRange();
      }
    } else {
      this.alertService.mostraAlerta("", "Necessário preencher todos os campos do formulário.");
    }
  }

  removerContrato(item, edit) {

    if (!edit) {
      this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
        if (callback) {
          let index = this.listaDados.indexOf(item);
          this.listaDados.splice(index, 1);

          if (item.id != 0) {
            this.deletarContrato(item.idContratoGestao, edit);
          }
        }
      });
    } else {
      // let index = this.listaDados.indexOf(item);
      // this.listaDados.splice(index, 1);

      if (item.id != 0) {
        this.deletarContrato(item.id, edit);
      }
    }
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaContratosGestao() {
    this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
  }

  salvar() {

    this.listEdit.forEach(item => {
      this.removerContrato(item, true);
    });

    this.listEdit = [];

    for (let j = 0; j < this.listaDados.length; j++) {

      if (this.listaDados[j].cnpj != null && this.listaDados[j].cnpj != undefined && this.listaDados[j].cnpj != '') {
        this.listaDados[j].cnpj = this.listaDados[j].cnpj.replace(/[^\d]+/g, '');
      } else if (this.listaDados[j].cpf != null && this.listaDados[j].cpf != undefined && this.listaDados[j].cpf != '') {
        this.listaDados[j].cpf = this.listaDados[j].cpf.replace(/[^\w\s]/gi, '');
      }
    }

    this.contratosGestaoService.salvarContratosGestao(this.listaDados).subscribe(data => {
      this.alertService.mostraAlerta("", "Salvo com sucesso.");
      this.carregarDados();
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
    })
  }

  deletarContrato(idContratoGestao, edit) {
    this.contratosGestaoService.deletarContrato(idContratoGestao).subscribe(data => {
      if (!edit) {
        this.alertService.mostraAlerta("", "Removido com sucesso.");
      }
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir:" + error);
    })
  }

  finalizar() {

    this.listEdit.forEach(item => {
      this.removerContrato(item, true);
    });

    this.listEdit = [];

    if (this.listaDados) {
      this.contratosGestaoService.finalizarContratosGestao(this.listaDados).subscribe(data => {
        this.alertService.mostraAlerta("", "Finalizado com sucesso.");
        this.voltarParaContratosGestao();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
      });
    }
  }

  onDateRangeChanged(event: IMyDateRangeModel) {

    if (event.formatted !== '') {

      this.border = '1px solid #CCC';

      this.contratoParaAdicionar.inicioVigencia = new Date(event.beginJsDate).toLocaleDateString('pt-br');
      this.contratoParaAdicionar.fimVigencia = new Date(event.endJsDate).toLocaleDateString('pt-br');

      if (+this.contratoParaAdicionar.inicioVigencia.split("/")[2] > this.PCAAtiva.dsAnoexercicio) {
        this.contratoParaAdicionar.inicioVigencia = '';
        this.contratoParaAdicionar.fimVigencia = '';
        this.clearDateRange();
        this.alertService.mostraAlerta("", "A Vigência do Contrato de Gestão não pode ser superior ao exercício da Prestação de Contas.");
      }

      // let copy = this.getCopyOfContratoOptions();

      // copy.componentDisabled = false;
      // copy.disableUntil = { year: event.beginJsDate.getFullYear(), month: event.beginJsDate.getMonth() + 1, day: event.beginJsDate.getDate() - 1 };
      // copy.disableSince = { year: event.endJsDate.getFullYear(), month: event.endJsDate.getMonth() + 1, day: event.endJsDate.getDate() + 1 };

      // this.myDateRangePickerOptions = copy;

    }
    else {
      this.selectedText = '';
      this.border = 'none';
    }
  }

  clearDateRange(): void {
    this.selectedDateRange = null;
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 10;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 10;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  onContratoChange(contrato) {

    if (contrato != null && contrato != undefined) {
      this.contratoParaAdicionar.dsCredor = contrato.credor;

      if (contrato.cnpj != null && contrato.cnpj != undefined && contrato.cnpj != '') {
        this.contratoParaAdicionar.cnpj = contrato.cnpj;
        this.habilita = true;
      } else if (contrato.cpf != null && contrato.cpf != undefined && contrato.cpf != '') {
        this.contratoParaAdicionar.cpf = contrato.cpf;
        this.habilita = false;
      }

      this.contratoParaAdicionar.inicioVigencia = contrato.inicioVigencia;
      this.contratoParaAdicionar.fimVigencia = contrato.novaDataVigencia ? contrato.novaDataVigencia : contrato.fimVigencia;
      this.contratoParaAdicionar.valorContratado = contrato.valorAtual ? contrato.valorAtual : contrato.valorInicial;
      this.contratoParaAdicionar.objeto = contrato.objeto;
      this.contratoParaAdicionar.nmContrato = contrato.nmContrato;

      this.objetoDateRange = {
        beginDate: {
          year: this.contratoParaAdicionar.inicioVigencia.split("/")[2],
          month: this.contratoParaAdicionar.inicioVigencia.split("/")[1].replace(/^0+/, ''),
          day: this.contratoParaAdicionar.inicioVigencia.split("/")[0].replace(/^0+/, '')
        },
        endDate: {
          year: this.contratoParaAdicionar.fimVigencia.split("/")[2],
          month: this.contratoParaAdicionar.fimVigencia.split("/")[1].replace(/^0+/, ''),
          day: this.contratoParaAdicionar.fimVigencia.split("/")[0].replace(/^0+/, '')
        }
      };
    } else {
      this.contratoParaAdicionar.dsCredor = '';
      this.contratoParaAdicionar.cnpj = '';
      this.contratoParaAdicionar.cpf = '';
      this.contratoParaAdicionar.inicioVigencia = '';
      this.contratoParaAdicionar.fimVigencia = '';
      this.contratoParaAdicionar.valorContratado = '';
      this.contratoParaAdicionar.objeto = '';
      this.contratoParaAdicionar.nmContrato = '';

      this.clearDateRange();
    }
  }

  atualizar(item) {
    this.contratoService.obterPorNumeroContrato(item.nmContrato).subscribe(data => {
      if(data){
        item.dsCredor = data.credor;
        item.cnpj = '';
        item.cpf = '';        
        if (data.cnpj != null && data.cnpj != undefined && data.cnpj != '') {
          item.cnpj = data.cnpj;
        } else if (data.cpf != null && data.cpf != undefined && data.cpf != '') {
          item.cpf = data.cpf;
        }
        item.inicioVigencia = data.inicioVigencia;
        item.fimVigencia = data.novaDataVigencia ? data.novaDataVigencia : data.fimVigencia;
        item.valorContratado = data.valorAtual ? data.valorAtual : data.valorInicial;
        item.objeto = data.objeto;
        item.nmContrato = data.nmContrato;
        this.alertService.mostraAlerta("Dados atualizados", "Para salvar a atualização, clique em Salvar ou Finalizar.");
      } else {
        this.alertService.mostraAlerta("", "Contrato não encontrado.");
      }    
    }, error => {
      this.alertService.mostraAlerta("Erro ao atualizar", "Não foi possível atualizar os dados do contrato.");
    });
  
  }

  printData() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Cadastro dos Contratos de Gestão", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Nº Contrato SAC/SCC", dataKey: "contrato" },
      { title: "Credor", dataKey: "org" },
      { title: "CPF/CNPJ", dataKey: "cpf" },
      { title: "Valor Contratado", dataKey: "valor" },
      { title: "Início Vigência", dataKey: "inicio" },
      { title: "Fim Vigência", dataKey: "fim" },
      { title: "Objeto", dataKey: "objeto" }
    ];

    let rows = [];

    this.listaDados.forEach(contrato => {

      var item = {
        "contrato": contrato.nmContrato,
        "org": contrato.dsCredor,
        "cpf": contrato.cpf != '' ? this.cpf_mask(contrato.cpf) : contrato.cnpj != '' ? this.cnpj_mask(contrato.cnpj) : "",
        "valor": this.formatarValorNumerico(contrato.valorContratado),
        "inicio": contrato.inicioVigencia,
        "fim": contrato.fimVigencia,
        "objeto": contrato.objeto
      };

      rows.push(item);
    });

    doc.autoTable(columns, rows, {
      theme: 'grid',
      addPageContent: pageContent,
      margin: { top: 30 },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'wrap',
        fontSize: 8
      },
      columnStyles: {
        objeto: { columnWidth: 'auto' }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('contratos_gestao.pdf');
  }

  modalEvidencias(item: any) {

    let titulo = "Evidências";

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: item.nmContrato,
        //idModuloPCA: this.codigoModulo,
        idModuloPCA: this.codigoModuloContrato,
        tipoAnalise: 0,
        jurisdicionado: false,
        isCGE: this.isCGE,
        pFlSefaz: 0,
        origemArquivo: "Processo: " + item.nmContrato,
        tipoEntidadeExercicio: 0,
        tipodocumento: 0,
        analise: this.analise,
        flPegaDocumentoDoModuloDeContrato: true
      });

    modal.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/cadastro-contratos/cadastro-contratos.ts